import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const sendCompanionLink = async (id: string) => {
  const resp = await api.post(`/bookings/${id}/companion-link`);
  queryClient.invalidateQueries(["messages"]);
  return resp;
};
